var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"bg-primary text-white py-2 px-4 rounded-md focus:outline-none focus:ring",class:{
    'bg-secondary text-gray-800': _vm.secondary,
    'opacity-75 cursor-not-allowed': _vm.disabled,
  },attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }